import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import { NotesClient } from '@src/notes/services/NotesClient';
import { useMutation } from '@tanstack/react-query';

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useAddNote = (props: Props) => {
  const { mutate } = useMutation({
    mutationFn: async (data: AddNoteRequest) => NotesClient.addNote(data),
    onSuccess: props.onSuccess,
    onError: props.onError,
  });

  return {
    addNote: mutate,
  };
};
